import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Grid, MenuItem, TextField } from '@mui/material';
import ConfirmModal from '../../modals/confirmx'; // Modal de confirmação
import FeedbackModal from '../../modals/FeedbackModal'; // Modal de feedback (loading, success, error)
import { Hourglass } from 'react-loader-spinner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { createSupplier } from '../../../services/api'; // Função para criar fornecedor

const CriarFornecedor = () => {
    // Estado com os campos conforme o modelo Supplier (em inglês)
    const [fornecedorData, setFornecedorData] = useState({
        name: '',
        type: 'local', // Valor padrão
        email: '',
        phone: '',
        address: '',
        website: '',
        contact: ''
    });

    // Estado para a modal de confirmação
    const [confirmVisible, setConfirmVisible] = useState(false);
    // Estados para feedback: loading, status (success/error) e mensagem
    const [loading, setLoading] = useState(false);
    const [feedbackStatus, setFeedbackStatus] = useState(''); // 'success' ou 'error'
    const [feedbackMessage, setFeedbackMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFornecedorData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // Validação simples de email
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Exibe a modal de confirmação
    const handleConfirm = () => {
        setConfirmVisible(true);
    };

    // Quando o usuário confirmar, cria o supplier
    const onConfirmCreate = async () => {
        setConfirmVisible(false);

        if (!isValidEmail(fornecedorData.email)) {
            alert('Please enter a valid email.');
            return;
        }

        setLoading(true);
        setFeedbackMessage('Creating supplier...');
        try {
            console.log('Payload enviado:', fornecedorData);
            const response = await createSupplier(fornecedorData);
            console.log('Supplier created:', response.data);
            setFeedbackStatus('success');
            setFeedbackMessage('Supplier created successfully!');
        } catch (error) {
            console.error('Error creating supplier:', error.response?.data);
            setFeedbackStatus('error');
            setFeedbackMessage('Error creating supplier.');
        } finally {
            setLoading(false);
            // Limpa o feedback após 2 segundos
            setTimeout(() => {
                setFeedbackMessage('');
                setFeedbackStatus('');
            }, 2000);
        }
    };

    const onCancelCreate = () => {
        setConfirmVisible(false);
    };

    const header = (
        <div>
            <h2>Create Supplier</h2>
        </div>
    );

    return (
        <Card header={header}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="name">Name</label>
                        <InputText 
                            id="name" 
                            name="name" 
                            value={fornecedorData.name} 
                            onChange={handleChange} 
                            style={{ width: '100%' }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    {/* Campo para selecionar o type */}
                    <TextField
                        select
                        label="Type"
                        name="type"
                        value={fornecedorData.type}
                        onChange={handleChange}
                        fullWidth
                    >
                        <MenuItem value="local">Local</MenuItem>
                        <MenuItem value="international">International</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="email">Email</label>
                        <InputText 
                            id="email" 
                            name="email" 
                            value={fornecedorData.email} 
                            onChange={handleChange} 
                            style={{ width: '100%' }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="phone">Phone</label>
                        <InputText 
                            id="phone" 
                            name="phone" 
                            value={fornecedorData.phone} 
                            onChange={handleChange} 
                            style={{ width: '100%' }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="p-field">
                        <label htmlFor="address">Address</label>
                        <InputText 
                            id="address" 
                            name="address" 
                            value={fornecedorData.address} 
                            onChange={handleChange} 
                            style={{ width: '100%' }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="website">Website</label>
                        <InputText 
                            id="website" 
                            name="website" 
                            value={fornecedorData.website} 
                            onChange={handleChange} 
                            style={{ width: '100%' }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <div className="p-field">
                        <label htmlFor="contact">Contact</label>
                        <InputText 
                            id="contact" 
                            name="contact" 
                            value={fornecedorData.contact} 
                            onChange={handleChange} 
                            style={{ width: '100%' }}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Button 
                        label="Confirm Creation" 
                        icon="pi pi-check" 
                        className="p-button-success" 
                        onClick={handleConfirm}
                    />
                </Grid>
            </Grid>
            <ConfirmModal
                visible={confirmVisible}
                message="Do you really want to create this supplier?"
                onConfirm={onConfirmCreate}
                onCancel={onCancelCreate}
            />
            <FeedbackModal
                open={loading || feedbackMessage !== ''}
                isSubmitting={loading}
                submissionComplete={feedbackStatus === 'success'}
                error={feedbackStatus === 'error' ? feedbackMessage : null}
                onClose={() => {
                    // Limpa o feedback ao fechar a modal
                    setFeedbackMessage('');
                    setFeedbackStatus('');
                }}
            />
        </Card>
    );
};

export default CriarFornecedor;
